function handlePOCart(){
  const noteArea = document.querySelector(".cart-instructions");
  const notePO = document.querySelector(".bss-b2b-custom-fields");
  const areaPO = notePO.querySelector("textarea");
  if(areaPO) {
      areaPO.placeholder = "PO#, Special Instructions, Comments"
  }
  noteArea.insertAdjacentElement("beforeBegin", notePO);
}

(() => {
  const isCart = window.location.pathname === '/cart';
  if(isCart) {
    document.addEventListener("DOMContentLoaded", e => {
      handlePOCart();
    })
  }
})();

document.addEventListener("DOMContentLoaded", e => {
    const poNote = document.querySelector(".bss-cart-custom-PO");
    poNote.value = '';
})

setTimeout(() => {
    // let variant = document.querySelectorAll('.product-options .single-option-selector')
    // if (variant.length) {
    //     variant.forEach((e) => {
    //         e.addEventListener("change", () => {
    //             let priceEle = document.querySelector(' [bss-b2b-product-form] [bss-b2b-product-id]')
    //             let productId = priceEle.getAttribute('bss-b2b-product-id')
    //             let product = BSS_B2B.storage.productStorage.get(Number(productId));

    //             if (product.variants.length) {
    //                 product.variants.forEach((ele) => {
    //                     if (ele.title == e.value) {
    //                         priceEle.setAttribute('bss-b2b-variant-id', ele.id)
    //                     }
    //                 })
    //             }
    //             setTimeout(async () => {
    //                 const res = await BSS_B2B.storage.productStorage.load();
    //                 if (res && (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size)) {

    //                     BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
    //                         ...res,
    //                     });
    //                 }
    //             }, 1000)
    //         });
    //     })
    // }

    function calculateDiscount(price, DiscountType, value) {
        const {
            ODiscountType
        } = BSS_B2B.enum;
        const rateMarket = Number(window.Shopify.currency.rate) || 1;
        let modifiedPrice = price;
        let discountValue = 0;
        const priceWithStoreCurrency = price / rateMarket;
        switch (type) {
            case ODiscountType.APPLY_FIXED:
                value = value * 100;
                if (value < priceWithStoreCurrency) {
                    discountValue = parseFloat(((priceWithStoreCurrency - value) / 100).toFixed(2));
                    discountValue = parseFloat((discountValue * rateMarket).toFixed(2)) * 100;
                    modifiedPrice = Math.round((price - discountValue) * 100) / 100;
                }
                break;
            case ODiscountType.DECREASE_FIXED:
                discountValue = value * rateMarket * 100;
                modifiedPrice = price > discountValue ? price - discountValue : 0;
                break;
            case ODiscountType.DECREASE_PERCENTAGE:
                discountValue = parseFloat(((priceWithStoreCurrency * value) / 100).toFixed(2));
                discountValue = parseFloat((discountValue * rateMarket).toFixed(2));
                modifiedPrice = price - discountValue;
                break;
            default:
                break;
        }
        return modifiedPrice;
    }

    let quickview = document.querySelectorAll('.quick-shop-modal-trigger')

    if (quickview.length) {
        quickview.forEach((e) => {
            e.addEventListener("click", (ele) => {
                setTimeout(async () => {
                  console.log(ele)
                    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'QuickviewLoaded', {
                        event: ele
                    });

                    const res = await BSS_B2B.storage.productStorage.load();


                    if (res && (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size)) {
                        BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                            ...res,
                        });
                    }


                    let changeVariant = document.querySelectorAll('.select-wrapper .single-option-selector')
                    if (changeVariant.length) {
                        changeVariant.forEach((e) => {
                            e.addEventListener("change", () => {
                               

                                document.querySelector('.product-details-wrapper .product-price').style.visibility = "hidden"
                                setTimeout(async () => {
                                    const res = await BSS_B2B.storage.productStorage.load();
                                    if (res && (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size)) {
                                        BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                                            ...res,
                                        });
                                    }
                                    document.querySelector('.product-details-wrapper .product-price').style.display = "visible"
                                }, 1000)
                            }) 
                        })
                    }
                }, 1000)
            });
        })
    }
    let quickAddDrawer = document.querySelector('.quickshop-content')
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach( async function(m) {
                 if (m.addedNodes.length) {
                  
                    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'QuickviewLoaded', {
                        event: m
                    });
                    const res = await BSS_B2B.storage.productStorage.load();

                    if (res && (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size)) {
                        BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                            ...res,
                        });
                    }
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }


}, 2000)